<template>
  <div>
    <business-header v-transition></business-header>
    <business-list :list="businessList" v-transition></business-list>
  </div>
</template>

<script>
import BusinessHeader from './components/Header'
import BusinessList from './components/List'
export default {
  name: 'Business',
  components: {
    BusinessHeader,
    BusinessList
  },
  data () {
    return {
      businessList: []
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/platform_goods/Business.vue